
import React, { Component, PropTypes } from 'react'
import stylesDocCss from './documents.scss'
import Modal from 'react-modal'
import cs from 'classnames'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
import * as c from 'state/constants'
import { findDocumentFromListById } from './DSWizardHelper'
import { connect } from 'react-redux'
import xss from 'xss'

// init translations
const _ = i18n('dswizard')
const TEMPLATE_ACCESS_URL = '/documentTemplates/'

@connect(
    (state) => {
        return {

        }
    }
)
export default class OpenDocumentToFillModal extends Component {
    static propTypes = {
        dataForEditDocument: PropTypes.any,
        packageDSDocuments: PropTypes.array,
        stakeholders: PropTypes.array,
        isOpen: PropTypes.bool,
        style: PropTypes.object,
        contentLabel: PropTypes.string,
        lang: PropTypes.string,
        packageId: PropTypes.string,
        onCancel: PropTypes.func,
        onSave: PropTypes.func,
        didClose: PropTypes.func,
        showWarningXss: PropTypes.func,
        renderTemplateOnly: PropTypes.bool,
        extraClassNameForContainer: PropTypes.any
    }

    constructor(props) {
        super(props)
        this.state = {}
        this.canvasImages = []
    }

    /**
     * Find input value from haystack of saved values of broker inputs, if not found then return default value.
     * @param {*} brokerFilledValues
     * @param {*} inputName
     * @param {*} defaultValue
     */
    findBrokerInputValueByInputName(brokerFilledValues, inputName, defaultValue = '') {
        if (!brokerFilledValues || brokerFilledValues.length === 0) {
            return defaultValue
        }

        let result = defaultValue

        brokerFilledValues.forEach((item) => {
            if (item.name + "" === inputName + "") {
                result = item.value
            }
        })

        return result
    }


    /**
     * This function will set the values for the HTML inside the iframe
     * @param {*} oneDocument
     */
    setIframeFormInputValues(oneDocument, dataSet) {
        let originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document
        let brokerFilledValues = nesProp.get(oneDocument, "brokerFilledValues")
        let placeholders = nesProp.get(dataSet, "placeholders") || []

        // in case of not saved values (maybe first visit of document), we can not fill nothing
        /* if (!brokerFilledValues || brokerFilledValues.length === 0) {
            return
        } */

        // the iframe is not reachable from some reason
        if (!originOfElemnts) {
            console.error("Can not set the input values automatically. DSDocument root is not reachable!")
            return
        }

        // find inputs in the dsdocument inframe to fill up with values
        let inputs = originOfElemnts.getElementsByTagName("input")
        let selects = originOfElemnts.getElementsByTagName("select")
        let textareas = originOfElemnts.getElementsByTagName("textarea")

        // The rest of types are ignored yet
        // TODO iterate the rest of types of elements in case
        //let optgroups = originOfElemnts.getElementsByTagName("optgroup")
        //let datalists = originOfElemnts.getElementsByTagName("datalist")
        //let outputs = originOfElemnts.getElementsByTagName("output")
        // fetch input values and names
        if (inputs && inputs.length > 0) {
            for (var i = 0, max = inputs.length; i < max; i++) {
                let oneInput = inputs[i]

                // if must fill an input value from dataset
                placeholders.forEach((onePlaceholder) => {
                    oneInput.value = String(oneInput.value)
                        .replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue)
                })

                // } else {
                switch (oneInput.type) {
                    case "checkbox": {
                        // set checked the input by pre-saved value
                        let savedInputValue = this.findBrokerInputValueByInputName(
                            brokerFilledValues,
                            oneInput.name,
                            Boolean(oneInput.checked)
                        )
                        // console.log('from checkbox ', oneInput);
                        // const attributeForConnective = oneInput.getAttribute('fieldforconnective')
                        // if (attributeForConnective) {
                        //     const rect = oneInput.getBoundingClientRect()
                        //     console.log('rect', rect);
                        //     console.log('elem value? ', oneInput.value);
                        // }

                        // prevent issues with stringy saved bool values
                        // set the value for checkbox
                        oneInput.checked = Boolean(savedInputValue === "false" ? false : savedInputValue)
                        let event = new Event('change', {
                            bubbles: true,
                            cancelable: true,
                        });
                        oneInput.dispatchEvent(event);
                        break
                    }
                    case "radio": {
                        // set checked the input by pre-saved value
                        let savedInputValue = this.findBrokerInputValueByInputName(
                            brokerFilledValues,
                            oneInput.name,
                            null
                        )

                        // prevent issues with stringy saved bool values
                        // set the value for radio
                        if (oneInput.value == savedInputValue) {
                            oneInput.checked = Boolean(savedInputValue === "false" ? false : true)
                        }
                        let event = new Event('change', {
                            bubbles: true,
                            cancelable: true,
                        });
                        oneInput.dispatchEvent(event);
                        break
                    }

                    default:
                        // set checked the input by pre-saved value
                        // console.log('from default', oneInput);
                        // const attributeForConnective = oneInput.getAttribute('fieldforconnective')
                        // if (attributeForConnective) {
                        //     const rect = oneInput.getBoundingClientRect()
                        //     console.log('rect', rect);
                        //     console.log('elem value? ', oneInput.value);
                        // }
                        const signerExceptionList = ['firstSignerFirstNamePlaceholder', 'firstSignerLastNamePlaceholder', 'firstSignerEmailPlaceholder', 'secondSignerFirstNamePlaceholder', 'secondSignerLastNamePlaceholder', 'secondSignerEmailPlaceholder']
                        if (!signerExceptionList.includes(oneInput.name)) {

                            let savedInputValue = this.findBrokerInputValueByInputName(
                                brokerFilledValues,
                                oneInput.name,
                                oneInput.value
                            )
                            oneInput.value = savedInputValue || oneInput.value
                        }
                }

                // }

            }
        }

        // fetch textareas values and names
        if (textareas && textareas.length > 0) {
            for (var i = 0, max = textareas.length; i < max; i++) {
                let oneTextarea = textareas[i]

                // if must fill an textarea value from dataset
                placeholders.forEach((onePlaceholder) => {
                    oneTextarea.value = String(oneTextarea.value)
                        .replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue)
                })

                // set checked the input by pre-saved value
                let savedInputValue = this.findBrokerInputValueByInputName(
                    brokerFilledValues,
                    oneTextarea.name,
                    String(oneTextarea.value).replace(/\n/g, '\\n')
                )

                oneTextarea.value = savedInputValue

            }
        }

        // fetch textareas values and names
        if (selects && selects.length > 0) {
            for (var i = 0, max = selects.length; i < max; i++) {
                let oneSelect = selects[i]

                let savedInputValue = this.findBrokerInputValueByInputName(
                    brokerFilledValues,
                    oneSelect.name,
                    oneSelect.options[oneSelect.selectedIndex]? oneSelect.options[oneSelect.selectedIndex].text : ''
                )

                let optionsList = oneSelect.getElementsByTagName('option')
                if (optionsList && optionsList.length > 0) {
                    for (var j = 0, max2 = optionsList.length; j < max2; j++) {
                        if(optionsList[j].text && optionsList[j].text+"" === savedInputValue+"") {
                            optionsList[j].selected = 'selected'
                        }
                    }
                }
            }
        }
    }

    /**
     * This function will set the dataSet values for the HTML inside the iframe
     * @param {*} dataSet
     * @param {*} oneDocument
     */
    setIframeFormDatasetValues(dataSet, oneDocument, optionsList, stakeholders) {
        let originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document

        // in case of not saved values (maybe first visit of document), we can not fill nothing
        if (!dataSet) {
            return
        }

        // the iframe is not reachable from some reason
        if (!originOfElemnts) {
            console.error("Can not set the dataSet values in DSDocument. DSDocument root is not reachable!")
            return
        }

        // find inputs in the dsdocument iframe to fill up with values

        // TODO in case of
        let bodyArray = originOfElemnts.getElementsByTagName("body")
        let placeholders = nesProp.get(dataSet, "placeholders")

        this.fillTextNodeValuesWithDataSet(nesProp.get(bodyArray, "0"), placeholders, optionsList, stakeholders)
    }

    /**
     *
     * @param {*} oneDocument
     */
    setIframeAnimationOnComplete(oneDocument) {
        let that = this

        let canvasOnComplete = function (canvasIds) {
            let canvasImages = []

            if (!canvasIds || canvasIds.length === 0) {
                console.warn("No 'canvasIds' array declared in the document template! Must be an Array with strings of canvas element ids.")
                return
            }

            for (var i = 0; i < canvasIds.length; i++) {
                const img = {};
                var imageIndex = -1;
                for (var j = 0; j < canvasImages.length; j++) {
                    var oneImage = canvasImages[j];
                    if (oneImage.canvasId === canvasIds[i]) {
                        imageIndex = j;
                    }
                }

                if (imageIndex === -1) {
                    canvasImages.push(img);
                    imageIndex = canvasImages.length - 1;
                }

                const oneCanvas = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document.getElementById(canvasIds[i]);

                if (oneCanvas) {
                    const scaleFactor = window.devicePixelRatio;

                    const displayedWidth = oneCanvas.offsetWidth;
                    const displayedHeight = oneCanvas.offsetHeight;

                    canvasImages[imageIndex].canvasId = canvasIds[i];
                    canvasImages[imageIndex].scaleFactor = scaleFactor; // not needed on server
                    canvasImages[imageIndex].width = oneCanvas.width / scaleFactor;
                    canvasImages[imageIndex].offsetWidth = displayedWidth;  // not needed on server
                    canvasImages[imageIndex].originalWidth =  oneCanvas.width;  // not needed on server
                    canvasImages[imageIndex].nonScaledWidth = oneCanvas.width / scaleFactor;  // not needed on server
                    canvasImages[imageIndex].scaledOffsetWidth = displayedWidth / scaleFactor;  // not needed on server
                    canvasImages[imageIndex].height = oneCanvas.height / scaleFactor;
                    canvasImages[imageIndex].offsetHeight = displayedHeight;  // not needed on server
                    canvasImages[imageIndex].originalHeight = oneCanvas.height;  // not needed on server
                    canvasImages[imageIndex].nonScaledHight = oneCanvas.height / scaleFactor;  // not needed on server
                    canvasImages[imageIndex].scaledOffsetHight = displayedHeight / scaleFactor;  // not needed on server
                    canvasImages[imageIndex].base64Data = oneCanvas.toDataURL("image/png").split(",")[1];
                }
            }

            that.canvasImages = canvasImages

            return canvasImages
        }

        // set inner function to external scope
        document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasOnComplete = canvasOnComplete
    }

    /**
     *
     * @param {*} node
     */
    fillTextNodeValuesWithDataSet(node, placeholders, optionsLists, stakeholders) {
        let patchText = (currentNode) => {

            // If the node is an element node, the nodeType property will return 1.
            // If the node is an attribute node, the nodeType property will return 2.
            // If the node is a text node, the nodeType property will return 3.
            // If the node is a comment node, the nodeType property will return 8.

            if (currentNode.nodeType === 3) {
                placeholders.forEach((onePlaceholder) => {
                    currentNode.nodeValue = String(currentNode.nodeValue)
                        .replace('{{' + onePlaceholder.placeholderName + '}}', onePlaceholder.placeholderValue)
                })
            }

            //Find Select placeholders and set the options lists than set selected values
            if (currentNode.nodeName === 'SELECT') {
                let optionsList = currentNode.getElementsByTagName('option')
                const datasetPlaceHolderNameFromTemplate = currentNode.getAttribute('dataset-placeholder-name')
                //set options list
                if(datasetPlaceHolderNameFromTemplate && optionsLists){
                    let optionsListsArray = []
                    optionsListsArray = optionsLists[datasetPlaceHolderNameFromTemplate].listValues

                    //crete a first empty option
                    const emptyOption = document.createElement('option')
                    emptyOption.value = ''
                    emptyOption.innerHTML = ''
                    currentNode.appendChild(emptyOption)

                    //create a nd add to options list a option for each list element from optionsListsArray
                    if (optionsListsArray) {
                        optionsListsArray.forEach(e => {
                            const option = document.createElement('option')
                            option.value = e.description
                            option.innerHTML = e.description
                            currentNode.appendChild(option)
                        })
                    }
                } else if(!optionsLists) {
                    console.warn('No options lists in datasets')
                }

                //determine selected value
                placeholders.forEach((onePlaceholder) => {
                    if(datasetPlaceHolderNameFromTemplate === onePlaceholder.placeholderName ){
                        if (optionsList && optionsList.length > 0) {
                            for (var j = 0, max2 = optionsList.length; j < max2; j++) {
                                if (optionsList[j].innerText && optionsList[j].innerText === onePlaceholder.placeholderValue) {
                                    optionsList[j].selected = 'selected'
                                }
                            }
                        }
                    }
                })
            }

            // find placeholders in src attributes of all nodes in the page, and replace the attribute value to the placeholder value
            if (currentNode && (typeof currentNode.getAttributeNode == 'function') && currentNode.getAttributeNode("src")) {
                placeholders.forEach((onePlaceholder) => {
                    if (currentNode.getAttributeNode("src").value == '{{' + onePlaceholder.placeholderName + '}}') {
                        currentNode.getAttributeNode("src").value = onePlaceholder.placeholderValue
                    }
                })
            }
            // Handle stakeholders form filling
            if (stakeholders) {
                if (currentNode.nodeName === 'INPUT' && currentNode.getAttributeNode('type').value === 'text') {
                    currentNode.value = currentNode.getAttribute('name') === 'firstSignerFirstNamePlaceholder' ? stakeholders[0].firstName :
                        (currentNode.getAttribute('name') === 'firstSignerLastNamePlaceholder' ? stakeholders[0].lastName :
                            (currentNode.value = currentNode.getAttribute('name') === 'firstSignerEmailPlaceholder' ? stakeholders[0].email :
                                (stakeholders.length > 1 ? (currentNode.getAttribute('name') === 'secondSignerFirstNamePlaceholder' ? stakeholders[1].firstName :
                                    (currentNode.getAttribute('name') === 'secondSignerLastNamePlaceholder' ? stakeholders[1].lastName :
                                        (currentNode.getAttribute('name') === 'secondSignerEmailPlaceholder' ? stakeholders[1].email : currentNode.value))
                                ) : currentNode.value)))
                }
            }

            if ((!stakeholders || stakeholders.length <= 1) && currentNode.classList && currentNode.classList.contains('{{hideSecondSignerClassPlaceholder}}')) {
                currentNode.classList.remove('{{hideSecondSignerClassPlaceholder}}')
                currentNode.classList.add('hideSecondSigner')
            }
        }
        this.findNextDomeNode(node, patchText)
    }

    /**
     *
     * @param {*} node
     * @param {*} cb
     */
    findNextDomeNode(node, cb) {
        cb(node)
        node = node.firstChild

        while (node) {
            this.findNextDomeNode(node, cb)
            node = node.nextSibling
        }
    }

    /**
     * This function will save the infill of a document to database and update error messages.
     * @param {*} oneDocument
     * @returns templateFromValues - the values from external template form values
     */
    async saveDocumentFill(oneDocument) {
        let { dispatch, lang, packageId, showWarningXss } = this.props

        let templateFormValues = getIframeFormInputValues(oneDocument)
        // if return boolean === false then there is no validation function declared
        let externalValidationResult = callIframeExternalValidation(oneDocument)

        const connectiveFormFields = getConnectiveFormFields(oneDocument)
        let errorMessages = []

        // first XSS check only for notify the user, exact the same XSS filtering will be applied on server side.
        if (templateFormValues) {
            let isThereXSSFiltered = false
            let suspectValues = {}

            Object.keys(templateFormValues).forEach((oneKey) => {
                if (typeof templateFormValues[oneKey].value === 'string') {
                    if (templateFormValues[oneKey].value !== xss(templateFormValues[oneKey].value)) {
                        isThereXSSFiltered = true
                        suspectValues[templateFormValues[oneKey].name] = templateFormValues[oneKey].value
                        templateFormValues[oneKey].value = ""
                    }
                }

                // check if required some if the inputs
                if (!templateFormValues[oneKey].value && templateFormValues[oneKey].required) {
                    errorMessages.push(
                        templateFormValues[oneKey].requiredMessage || (templateFormValues[oneKey].name + " " + _("templateFieldIsRequired"))
                    )
                }
            })

            // validate here, validation exist if the result is not === false.
            if (externalValidationResult !== false && !externalValidationResult.isValid) {
                // remove from result the validity flag because all of the other properties are fields with error reports
                delete externalValidationResult.isValid

                let fieldsListWithError = Object.keys(externalValidationResult)

                if (fieldsListWithError && fieldsListWithError.length > 0) {
                    fieldsListWithError.forEach((oneErrorKey) => {
                        errorMessages.push(
                            nesProp.get(externalValidationResult, oneErrorKey + ".message." + lang) ||
                            nesProp.get(externalValidationResult, oneErrorKey + ".message.nl") ||
                            (oneErrorKey + " " + _("templateFieldIsRequired"))
                        )
                    })
                } else {
                    errorMessages.push(
                        _("unknownErrorInTemplateForm")
                    )
                }
            }

            // got some issue with XSS filtering
            if (isThereXSSFiltered) {
                showWarningXss(isThereXSSFiltered, suspectValues)
            }
        }

        // prepare final result to update the already existing document only by the follwoing properties
        let documentUpdateThisProps = {
            documentData: {
                _id: oneDocument._id,
                brokerFilledValues: templateFormValues,
                errorMessages: errorMessages
            },
            connectiveFormFields
        }

        return documentUpdateThisProps

        /*
        packageDSDocuments = attachIdResult.packageDSDocuments
        // immediately update the document in state to show the actualised data on render
        packageDSDocuments = packageDocumentsListUpdateByDocument(packageDSDocuments, updatedDocument) //sync

        // invalid fill of template
        if (errorMessages.length > 0) {
            let errorInstance = new Error()
            errorInstance.error = errorMessages
            throw errorInstance
        }

        // return final promise: resolved if template filled correctly else reject it.
        return templateFormValues */
    }

    renderContent() {
        const { dataForEditDocument, stakeholders, didClose, onCancel, onSave, packageDSDocuments, parentModule } = this.props
        const dataSet = nesProp.get(dataForEditDocument, "dataSet")
        const optionsLists = nesProp.get(dataForEditDocument, "optionsLists")
        let oneDocument = nesProp.get(dataForEditDocument, "oneDocument")

        if (!oneDocument || !dataSet) {
            return <div>...</div>
        }

        // update doc instance from the state
        oneDocument = findDocumentFromListById(oneDocument._id, packageDSDocuments)

        let docLang = nesProp.get(oneDocument, "language")
        let langIndex = ((docLang === 'nl') ? 0 : (docLang === 'fr' ? 1 : 2))
        let popupTitle = nesProp.get(oneDocument, "documentTemplate.title." + (docLang || 'nl'))
        let htmlContentLink = TEMPLATE_ACCESS_URL + nesProp.get(oneDocument, "documentTemplate.templateContent.htmlPath." + langIndex)

        // in case fo rerender the iframe will be reloaded, use this flag to know the state of load
        // this.iframeLoaded = false

        return (<div
            className={cs(stylesDocCss.documentsModalContent, stylesDocCss.maximizeModalContent)} key={oneDocument._id + Math.random()}
            id="templateHolderDiv"
        >
            <span className={stylesDocCss.title}>{_('fillDocumentModalTitle') + " - " + popupTitle}</span>
            <span className={stylesDocCss.message}>
                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>
                    {_('fillDocumentModalContent')}
                </div>

                <div className={cs(stylesDocCss.iframeContainer, this.props.extraClassNameForContainer)}>
                    <iframe
                        ref={c.DSDOC_IFRAME_PRE_REF + oneDocument._id}
                        src={htmlContentLink} width="100%"
                        id={c.DSDOC_IFRAME_PRE_REF + oneDocument._id}
                        onLoad={() => {
                            this.setIframeAnimationOnComplete(oneDocument)
                            this.setIframeFormDatasetValues(dataSet, oneDocument, optionsLists, stakeholders)
                            this.setIframeFormInputValues(oneDocument, dataSet)
                            callIframeExternalOnFieldValuesLoaded(oneDocument)
                        }}
                    />
                </div>
            </span>
            <div className={stylesDocCss.documentsModalButtons}>
                <div
                    onClick={() => {
                        onCancel()
                        didClose()
                    }}
                    className={stylesDocCss.cancel}
                >
                    {_("cancel")}
                </div>
                <div
                    onClick={async (e) => {
                        try {
                            let documentUpdateThisProps = await this.saveDocumentFill(oneDocument)

                            // console.log("canvasIds", document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasIds)
                            // make initial call to get the canvas images by default minimum once, a further call will update the values
                            try {
                                document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasOnComplete(
                                    document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.canvasIds
                                )
                            } catch (err) {
                                console.warn("canvasOnComplete error", err)
                            }

                            await onSave(documentUpdateThisProps, this.canvasImages)
                            await didClose(documentUpdateThisProps)
                        } catch (err) {
                            console.error(err)
                            didClose(err.error)
                        }

                        return
                    }}
                    className={stylesDocCss.greenButton + " enabled"}
                >
                    {parentModule === c.WEBAPPS ? _("exportPdfForWebapps") : _("save")}
                </div>
            </div>
        </div>)

    }

    /**
     * Content of are you sure modal
     */
    render() {
        const { style, isOpen, contentLabel, renderTemplateOnly } = this.props

        if (renderTemplateOnly) {
            return (this.renderContent())
        }

        return (
            <Modal
                isOpen={isOpen}
                style={style}
                contentLabel={contentLabel}
                key={"OpenDocumentToFillModalKey"}
            >
                {this.renderContent()}
            </Modal>
        )
    }
}


/**
* This function will collect the values from the HTML inside the iframe
* @param {*} oneDocument
*/
export const getIframeFormInputValues = (oneDocument) => {

    let originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document

    if (!originOfElemnts) {
        return
    }

    let inputs = originOfElemnts.getElementsByTagName("input")
    let selects = originOfElemnts.getElementsByTagName("select")
    let textareas = originOfElemnts.getElementsByTagName("textarea")

    // The rest of types are ignored yet
    // in case of future requirements iterate the rest of types of elements in case
    //let optgroups = originOfElemnts.getElementsByTagName("optgroup")
    //let datalists = originOfElemnts.getElementsByTagName("datalist")
    //let outputs = originOfElemnts.getElementsByTagName("output")

    let result = []

    // fetch input values and names
    if (inputs && inputs.length > 0) {
        for (var i = 0, max = inputs.length; i < max; i++) {
            let oneInput = inputs[i]

            switch (oneInput.type) {
                case "checkbox": {
                    result.push({
                        name: oneInput.name,
                        value: Boolean(oneInput.checked),
                        inputType: "checkbox",
                        required: !!oneInput.required,
                        requiredMessage: oneInput.getAttribute("data-requiredmessage")
                    })
                    break
                }
                case "radio":
                    if (Boolean(oneInput.checked)) {
                        result.push({
                            name: oneInput.name,
                            value: oneInput.value,
                            inputType: "radio",
                            required: !!oneInput.required,
                            requiredMessage: oneInput.getAttribute("data-requiredmessage")
                        })
                    }
                    break
                default:
                    //result.push({name: oneInput.name, value: escapeSpecialChars(oneInput.value), inputType: "text"})
                    result.push({
                        name: oneInput.name,
                        value: oneInput.value,
                        inputType: "text",
                        required: !!oneInput.required,
                        requiredMessage: oneInput.getAttribute("data-requiredmessage")
                    })
            }
        }
    }

    // fetch textareas values and names
    if (textareas && textareas.length > 0) {
        for (var i = 0, max = textareas.length; i < max; i++) {
            let oneTextarea = textareas[i]
            result.push({
                name: oneTextarea.name,
                value: oneTextarea.value,
                inputType: "textarea",
                required: !!oneTextarea.required,
                requiredMessage: oneTextarea.getAttribute("data-requiredmessage")
            })
        }
    }

    // fetch textareas values and names
    if (selects && selects.length > 0) {
        for (var i = 0, max = selects.length; i < max; i++) {
            let oneSelect = selects[i]
            let selectOptionText = oneSelect.options[oneSelect.selectedIndex].text

            //to be shown the text in the final document as when displayed in the wizard
            result.push({
                name: oneSelect.name,
                value: selectOptionText,
                inputType: "select",
                required: !!oneSelect.required,
                requiredMessage: oneSelect.getAttribute("data-requiredmessage")
            })
        }
    }

    return result
}

/**
 * Extract fields marked for connective from the template
 * 
 * @param {*} oneDocument 
 * @returns 
 */
const getConnectiveFormFields = (oneDocument) => {
    const originOfElemnts = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.document

    if (!originOfElemnts) return []

    const inputs = originOfElemnts.getElementsByTagName("input")

    const result = []

    if (inputs && inputs.length > 0) {
        for (const oneInput of inputs) {

            const attributeForConnective = oneInput.getAttribute('data-connectiveformfield')
            if (attributeForConnective) {
                const tooltip = oneInput.getAttribute('data-tooltip')
                const label = oneInput.getAttribute('data-label')
                const isRequired = oneInput.getAttribute('data-required')
                const elementHeight = oneInput.clientHeight
                const elementWidth = oneInput.clientWidth
                const connectiveFormElement = {
                    name: attributeForConnective,
                    dsDocumentId: oneDocument._id,
                    label: label || '',
                    toolTipLabel: tooltip || '',
                    isRequired: isRequired || false,
                    height:  Math.ceil(elementHeight * 0.8),
                    width: Math.ceil(elementWidth * 0.8)
                }
                switch (oneInput.type) {
                    case "checkbox": {
                        connectiveFormElement.type = 'CheckBoxField'
                        connectiveFormElement.defaultValue = oneInput.checked
                        result.push(connectiveFormElement)
                    }

                        break;
                    case "radio": {
                        connectiveFormElement.type = 'RadioGroup'
                        connectiveFormElement.defaultValue = oneInput.checked
                        result.push(connectiveFormElement)
                    }
                        break
                    default: {
                        connectiveFormElement.height = Math.ceil(elementHeight * 1)
                        connectiveFormElement.width = Math.ceil(elementWidth * 0.65)
                        connectiveFormElement.type = 'TextBoxField'
                        connectiveFormElement.defaultValue = oneInput.value
                        result.push(connectiveFormElement)
                    }
                        break;
                }
            }
        }
        return result
    }
}

/**
 * get the validate function fom template
 * @param {*} oneDocument
 * @returns {Object} || {Boolean} - If return true then there is no validation function else return object, validation result
 */
export const callIframeExternalValidation = (oneDocument) => {
    let validationResult = false

    if (typeof document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.validate === "function") {
        validationResult = document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.validate()
    }

    return validationResult
}

/**
 * Call the onFieldValuesLoaded external callback function. This function wll be called after
 * the iframe field values are loaded, to give a chance to template makers to set controls read-only and/or
 * do sime other value-related initialiations
 * @param {*} oneDocument
 */
export const callIframeExternalOnFieldValuesLoaded = (oneDocument) => {

    if (typeof document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.onFieldValuesLoaded === "function") {
        document.getElementById(c.DSDOC_IFRAME_PRE_REF + oneDocument._id).contentWindow.onFieldValuesLoaded()
    }
}

/**
 * Get the canvasImages data fom template
 * @param {*} oneDocument
 * @returns {Object} || {Boolean} - If return whit canvasImages else return false, validation result
    return format:
    [
        0: {
            canvasId: <sting>,
            base64Data: <string> base64 encoded,
            width: <number>,
            height: <number>
        },
            ... an so on, if there are more canvas elements in the template
    ]
 */


// WEBPACK FOOTER //
// ./components/DSDocuments/OpenDocumentToFillModal.jsx